import {
    WithStyles,
    withStyles,
    Grid,
    Typography,
    Chip,
    Theme,
    createStyles,
    Paper,
    Divider,
    Button,
  } from "@material-ui/core";
  import React, { Component, version } from "react";
  import { connect } from "react-redux";
  import { MyPATDialog, MyPATDropdown } from "../../common";
  import _ from 'lodash';
  import { RouteComponentProps, withRouter } from 'react-router-dom';
  import { bindActionCreators } from "redux";
  import {Package,Version} from '../types/interfaces/CourseBasicDetails';
  import { format } from "date-fns";
import CustomInfoIcon from "../../common/CustomInfoIcon";
import { CourseTypes } from '../types/enums/CourseTypes';
import { url } from "inspector";
import { VERSION_PROPERTY } from '../Constants/constants';
import cx from 'classnames'

  const styles = (theme: Theme) => createStyles({
    videoBorder: {
      borderLeft: 'solid 6px #F8AA4B'
    },
    notesBorder: {
      borderLeft: 'solid 6px #B881E3'
    },
    testBorder: {
      borderLeft: 'solid 6px #F49393'
    },
    questionBorder: {
      borderLeft: 'solid 6px #78D2A7'
    },
    cardFooter: {
      padding: '5px',
      background: 'rgb(246, 246, 246)',
      borderRadius: 4
    },
    cardLeftSection: {
      maxWidth: '8%',
      minWidth: '90px',
      position: 'absolute',
      marginTop: 2
    },
    cardRightSection: {
      paddingLeft: '8%',
      width: '100%',
      textDecoration: 'none'
    },
    draftElements: {
      '&>:nth-child(1)': {
        paddingRight: 10,
        textAlign: 'right'
      }
    },
    paper: {
      background: 'rgb(255, 255, 255)',
      boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
      borderRadius: 8,
      margin: "4px 0px 12px",
      '& .content-status': {
        display: 'block'
      },
      '& .content-preview': {
        display: 'none'
      },
      '&:hover': {
        boxShadow: '0px 4px 10px 0px #babfc5'
      }
    },
    checkbox: {
      padding: theme.spacing.unit / 4,
      top: 0,
      left: 2,
      width: 16,
      height: 16,
      '-moz-appearance': 'none',
      opacity: 1,
      color: 'rgb(204, 204, 204)',
      backgroundColor: '#fff',
      border: '1px solid #979797',
      borderRadius: 2,
      '& svg': {
        fontSize: '1.5rem',
        fontFamily: '"Nunito", sans-serif',
        fill: '#979797',
        opacity: 0
      }
    },
    checkedCheckbox: {
      backgroundColor: '#1d7dea',
      border: '1px solid #1d7dea',
      borderRadius: 2,
      color: '#99a1a7',
      '&::before': {
        content: "''",
        fontSize: 14,
        position: 'absolute',
        top: 0,
        left: 4,
        width: 4,
        height: 8,
        border: 'solid #fff',
        borderWidth: '0 2px 2px 0',
        transform: 'rotate(45deg)'
      },
      '&:hover': {
        backgroundColor: '#1d7dea'
      }
    },
    primaryColor: {
      color: 'rgb(29 125 234)'
    },
    customChip:{
      alignSelf: 'center',
      '&>div':{
        marginLeft: 12,
        height: 20,
        borderRadius: 10,
      }
    },
    chipLabel: {
      display: 'block',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      fontFamily: '"Nunito", sans-serif',
      textOverflow: 'ellipsis',
      fontWeight: 400,
      fontSize: 12,
      textTransform: 'capitalize',
      padding: '5px 10px',
    },
    favourite: {
      padding: 0,
      margin: '0px 16px'
    },
    favouriteIcon: {
      fontSize: 22,
      fontFamily: '"Nunito", sans-serif',
      fill: '#FDCC0C'
    },
    gridSpacing28: {
      width: 'calc(100% + 0px)',
      margin: '-12px 12px'
    },
    width80per:{
      width: '65%'
    },
    incompleteColor:{
      fontSize: 12,
      fontWeight: 400,
      color: '#F4B40D',
      marginLeft: 8
    },
    courseTitle:{
      fontWeight:600,
      fontSize:24,
      color: '#333',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      display: 'inline-block',
      maxWidth: '100%'
    },
    imageAlign:{
      display: 'flex',
      alignItems: 'center',
      '&>img':{
        verticalAlign: '-8px'
      }
    },
    versionName:{
      fontSize: 14,
      lineHeight: '20px',
      fontWeight: 600,
      color: '#333',
      textTransform: 'capitalize'
    },
    versionLabel:{
      fontSize: 14,
      fontWeight: 600,
      color: '#333',
      marginLeft: 24
    },
    versionRank:{
      fontSize: 14,
      fontWeight: 400,
      color: '#666'
    },
    dateStyle:{
      fontWeight:400,
      fontSize:16,
      lineHeight:'20px',
      color: '#333',
      '&>span':{
        fontWeight: 'normal',
        color: '#999999',
      }
    },
    courseName:{
      fontWeight:400,
      fontSize:16,
      lineHeight:'20px',
      color: "#666",
      marginLeft: 10,
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      maxWidth:500,
      display: "inline-block",
    },
    textEllipsis: {
      maxWidth: 590,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      paddingRight: theme.spacing.unit,
      fontSize: '16px',
      fontWeight: 'normal',
    },
    title: {
      lineHeight: theme.spacing.unit * 4 + "px",
      color: '#333333',
      maxWidth: 190,
      fontWeight: 600,
      paddingRight: 0
    },
    concept: {
      opacity: 0.8,
      lineHeight: theme.spacing.unit * 4 + "px",
    },
    contentTypeIcon: {
      display: 'inline-block',
      verticalAlign: 'middle',
      padding: '10px 0px'
    },
    subTitle: {
      padding: '4px 0px 4px 0px',
      color: 'rgb(153 153 153)'
    },
    contentType: {
      padding: '3px 0px',
      maxWidth: 126,
      background: '#FFF',
      border: '1px solid #60768C',
      boxSizing: 'border-box',
      borderRadius: 10,
      height: 20,
      margin: 6
    },
    contentProgress: {
      display: 'inline-block',
      width: '100px',
      height: '12px',
      borderRadius: '5px',
      background: theme.palette.background.default,
      marginRight: '2px',
      '& span': {
        background: '#E8E8E8',
        borderRadius: '5.5px 5px 5px 5.5px',
        display: 'block',
        height: '100%'
      }
    },
    statusButton: {
      color: '#1D7DEA',
      padding: '2px 8px 2px !important',
      fontSize: 12,
      border: '1px solid #1D7DEA',
      boxSizing: 'border-box',
      borderRadius: 10,
      fontWeight: 600
    },
    mainContentArea: {
      position: 'relative',
      padding: '16px 20px',
      cursor: 'pointer',
      '& .batchCenterRow': {
        display: 'flex',
        padding: 0,
        listStyle: 'none',
        margin: 0,
        '&>li': {
          position: 'relative',
          padding: '0 15px',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          '&:first-child': {
            paddingLeft: 0,
          },
          '&:last-child': {
            paddingRight: 0,
            '&::after': {
              display: 'none',
            }
          },
          '&::after': {
            content: "''",
            position: 'absolute',
            width: 4,
            height: 4,
            borderRadius: '50%',
            backgroundColor: '#D9D9D9',
            right: 2,
            top: 9,
          },
        }
      },
      '& .batchCenterName': {
        display: 'flex',
        '& .titleHead': {
          margin: '0',
          fontSize: '16px',
          fontWeight: 400,
          color: '#666666',
        },
        '& .batchCenterListing': {
          listStyle: 'none',
          display: 'inline-flex',
          margin: 0,
          padding: 0,
          '& li': {
            fontSize: '16px',
            fontWeight: 400,
            color: '#333333',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '160px',
            '&::after': {
              content: "','",
              margin: '0 5px',
            },
            '&:last-child::after': {
              display: 'none',
            },
          }
        },
        '& .batchCenterText': {
          minWidth: '30px',
          position: 'relative',
          marginLeft: '5px',
          fontSize: '16px',
          fontWeight: 500,
          color: '#1D7DEA',
        }
      }
    },
    batchDetailsModal: {
      maxWidth: 480,
      maxHeight: '100%',
      '&>div:first-child>div:first-child': {
        paddingTop: 0,
        minWidth: '100%',
        maxHeight: '100%',
        '&>div:first-child': {
          padding: '28px 5px 0',
        },
      },
      '& .closeBtn': {
        background: 'transparent',
        border: 0,
        padding: 0,
        position: 'absolute',
        right: 25,
        top: 30,
        cursor: 'pointer',
      },
      '& .title': {
        fontSize: 24,
        fontWeight: 400,
        lineHeight: '20px',
        color: '#000000',
        margin: '0 0 22.5px',
        textAlign: 'center',
      },
      '& .batchListingCol': {
        height: 230,
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          width: 6,
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: '#ffffff',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#D9D9D9',
          borderRadius: 30,
        },
      },
      '& .batchListing': {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        margin: '0 auto',
        maxWidth: 394,
        padding: 0,
        listStyle: 'none',
        '& li': {
          margin: '7.5px 7.5px',
          border: 'solid 1px #E2E2E2',
          borderRadius: 30,
          padding: '8px 15px',
          fontSize: 14,
          fontWeight: 400,
          color: '#666666',
          cursor: 'pointer',
        },
      },
      '& .centerListingCol': {
        height: 250,
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          width: 6,
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: '#ffffff',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#D9D9D9',
          borderRadius: 30,
        },
      },
      '& .centerListing': {
        listStyle: 'none',
        padding: '0 15px',
        margin: 0,
        '& li': {
          border: 'solid 1px #DDE2E5',
          borderRadius: 4,
          padding: '11px 15px',
          fontSize: 16,
          lineHeight: '20px',
          fontWeight: 400,
          color: '#666666',
          width: '100%',
          display: 'flex',
          marginBottom: 10,
          cursor: 'pointer',
          '& .badge': {
            fontSize: 12,
            fontWeight: 400,
            color: '#999999',
            lineHeight: '16.37px',
            backgroundColor: '#F4F4F4',
            borderRadius: 30,
            padding: '2px 8px',
            whiteSpace: 'nowrap',
            alignSelf: 'flex-start',
            marginRight: 14,
          }
        }
      },
    },
    businessType:{
      fontSize: 16,
      fontWeight: 400,
      color: '#333333',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '160px',
    },
    batchCenterBusinessBox: {
      position: 'relative',
      '&::before': {
        content: "''",
        top: '0',
        left: '0',
        right: '0',
        width: 'calc(100% - 40px)',
        height: '1px',
        margin: '0 auto',
        position: 'absolute',
        backgroundColor: '#DDDDDD',
      },
    },
    publishButton: {
      background: '#FFF',
    },
    inReviewButton: {
      background: '#B3B4B3',
    },
    liveButton: {
      background: '#FFF',
      color: '#67BF02',
      border: '1px solid #67BF02'
    },
    plannedButton: {
      background: '#fff',
      color: '#979797',
      border: '1px solid #979797',
    },
    deleteButton: {
      background: '#CCCCCC',
    },
    paddingSm: {
      padding: '10px 6px 0px'
    },
    previewButton: {
      background: theme.palette.common.white,
      border: '1px solid #DDDDDD',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.0519701)',
      padding: theme.spacing.unit,
      paddingTop: 2,
      opacity: 0.7,
      '& svg': {
        marginRight: theme.spacing.unit
      }
    },
    statusText: {
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      fontSize: 14,
      color: '#666666',
      padding: '4px 0px'
    },
    viewDetails: {
      fontSize: 14,
      color: 'rgb(51 51 51)',
      cursor: 'pointer',
      paddingLeft: 6,
      maxWidth: 340,
        '&:hover:after': {
          content: '""',
          position: 'absolute',
          left: '18%',
          marginLeft: -6,
          bottom: 8,
          width: 0,
          height: 0,
          borderLeft: '5px solid rgba(0, 0, 0, 0)',
          borderRight: '5px solid rgba(0, 0, 0, 0)',
          borderBottom: '8px solid rgb(222 222 222)'
        
        },
      '&:hover': {
        color: '#000',
        '& .infoContainer': {
          display: 'block'
        }
      },
      '& .infoContainer': {
        position: 'absolute',
        width: '90%',
        left: 100,
        bottom: 16,
        display: 'none',
        '&>:first-child': {
          background: 'rgb(222 222 222)',
          color: '#000',
          fontWeight: 600,
          maxWidth: '90%'
        }
      }
    },
    borderRightPublished: {
      borderRight: 'solid #3399F7 10px'
    },
    borderRightLive: {
      borderRight: 'solid #8ECE30 10px'
    },
    borderRightInReview: {
      borderRight: 'solid #B3B4B3 10px'
    },
    borderRightPlanned: {
      borderRight: 'solid #FF830F 10px'
    },
    colorSecondary: {
      backgroundColor: '#EB4F4F',
      color: '5.5px 5px 5px 5.5px'
    },
    progressBar: {
      borderRadius: 5
    },
    linearProgressBar: {
      borderRadius: 5,
      padding: 2,
      margin: '4px 18px',
      backgroundColor: '#E8E8E8',
      width: 54
    },
    // Variation Queation card
    grayCard:{
      backgroundColor: '#F8F8F8',
      borderRadius: 8,
      marginBottom: 8,
      padding: '8px 14px',
      width: '100%',
      position: 'relative',
    },
    variationCardChekbox:{
      position: 'absolute',
      left: '-5%',
    },
    creatorName:{
      color: '#999',
      fontSize: '14px',
      fontWeight: 600,
      '&>span':{
        color: '#515C65',
      },
    },
    collapseLink:{
      zIndex: 9,
      position: 'absolute',
        right: '10px',
      '&>:first-child':{
        fontSize: '14px',
        fontWeight: 600,
        color: '#1d7dea',
        marginRight: 8,
        '&:hover':{
          textShadow: '2px 2px 4px #d1d1d1'
        }
      },
      '&>img':{
        marginLeft: '4px',
      },
    },
    arrowIcon:{
          '&>img':{
              transform: 'rotate(180deg)',
              // marginLeft: '43px',
          }
      },
      rotateImg:{
          transform: 'rotate(0deg)',
    },
    slideDownAnimation:{
      transition: '0.5s',
    },
    ml12:{
      marginLeft: 12,
    },
    width90Per:{
      width: '90%'
    }	,
    liveColor:{
      color:'#67BF02 !important',
      borderColor:'#67BF02 !important'
    },
    draftColor:{
      color:'#F4B40D !important',
      borderColor:'#F4B40D !important'
    },
    publishColor:{
      color:'#1D7DEA !important',
      borderColor:'#1D7DEA !important'
    },
    pastColor:{
      color:'#D9505D !important',
      borderColor:'#D9505D !important'
    },

    tooltipDetails: {
      position: 'absolute',
      marginTop: 24,
      zIndex: 999999,
      marginLeft: 40,
  },
  });
  
  interface CourseCardProps extends WithStyles<typeof styles>{
    course:Package;
    classes:any;
    history: any;
  }
  
  interface CourseCardState {
   showVersion:boolean,
   showTooltip: boolean,
   selectedHoverCourse: string,
   batchContainerList: any[];
   centerContainerList: any[];
  }
  
  class CourseCard extends Component<CourseCardProps, CourseCardState> {
    constructor(props: CourseCardProps) {
      super(props);
      this.state = {
        showVersion:false,
        showTooltip: false,
        selectedHoverCourse: '',
        batchContainerList: [],
        centerContainerList: [],
      };
      this.getTooltipValue = this.getTooltipValue.bind(this);
      this.handleOnClick = this.handleOnClick.bind(this);
    }

    batchPopupClick = (batchContainerList: any[]) => {
      this.setState({ batchContainerList });
    }

    centerPopupClick = (centerContainerList: any[]) => {
      this.setState({ centerContainerList });
    }
  
    componentDidMount = () => {
    }
    handleVersion = (event: any) =>{
      event.stopPropagation();
      this.setState({
        showVersion: !this.state.showVersion
      })
   }

   handleHover(event: any) {
    this.setState({
      showTooltip: !this.state.showTooltip,
      selectedHoverCourse: event.target.id
    })
  }

   getStatusColorCode=(status:string)=>{
      const {classes } = this.props
      switch (status.toLowerCase()) {
        case "draft":
          return classes.draftColor
        case "live":
          return classes.liveColor
        case "past":
              return classes.pastColor
        default:
          return classes.publishColor
      }
   }
   addVersion=(course:Package)=>{
       if(!course.versions){
         const tempVersion:Version={
          expiryDate: "2016-07-31T00:00:00.000Z",
          name: "version",
          sku: "JEEM-04 - 2016",
          status: "Draft",
          id: "5ace21f09fe7b01d5807566c",
          startDate:"2002-09-31T00:00:00.000Z",
          goalLevels:{
            id:'5ace21f09fe7b01d5807566c',
            name:'JEE'
          },
           createdAt: '2002-08-31T00:00:00.000Z',
           availableForB2C: false,
           availableForCRP: false,
           availableForNCRP: false
         }
          course.versions=[tempVersion]
       }
   }
   handleOnClick = (id: string,type?:string,status?:string) => {
    const { history } = this.props;
    if(type==='testSeries'){
      if(status && status.toLowerCase()==='draft')
         history.push(`/course-Management/testSeries/${id}`);
      else 
      history.push(`/course-Management/testSeries/${id}/preview`);
    }
    // else if(type==='version'){
    //   history.push(`/course-Management/coursePlanPreview/${id}?type=version`);
    // }
    else 
      history.push(`/course-Management/coursePlanPreview/${id}`);
  }
    displayListLength = (list: any[] = []) => {
      return Math.max(list.length - 1, 0);
    }

    displayListName = (list: any[] = [], property: string) => {
      const newList = list.slice(0, 1).map((data: any) => {
        let displayName = data;
        if (data && data.hasOwnProperty(property)) {
          displayName = data[property];
        }
        return displayName;
      });
      return newList.join(', ');
    }

    showBatchAndCenter(courseInfo: any) {
      const { classes } = this.props;
      const { centerContainerList = [], batchContainerList = [] } = this.state;
      const centerList: any = courseInfo.centers || [];
      const batchList: any = this.getBatchList(centerList);
      const batchCenterVisible = !!centerList.length || this.getBusinessTypeAvailability(courseInfo);

      return (batchCenterVisible && <Grid item xs={12} className={cx(classes.mainContentArea, classes.batchCenterBusinessBox)}>
        <ul className='batchCenterRow'>
          {!!centerList.length && <> <li>
            {!!batchList.length && <div className="batchCenterName">
              <h6 className='titleHead'>Batch: </h6>&nbsp;
              <ul className='batchCenterListing'>
                <li>{this.displayListName(batchList, '')}</li>
              </ul>
              {!!this.displayListLength(batchList) && <span className='batchCenterText' onClick={() => this.batchPopupClick(batchList)}>+{this.displayListLength(batchList)}</span>}
              <MyPATDialog
                classes={{ root: classes.batchDetailsModal }}
                dialogOpen={batchContainerList.length}
                onDialogClose={false}
                otherDialogProps={{
                  fullWidth: true,
                  maxWidth: 'sm',
                }}
              >
                <button className='closeBtn' onClick={() => this.batchPopupClick([])}><img src='/assets/svg/course-plan-request/close-modal-ic.svg' alt='Close' /></button>
                <h6 className='title'>Batch Details</h6>
                <div className='batchListingCol'>
                  <ul className='batchListing'>
                    {(batchContainerList || []).map((batch: any, index: number) =>
                      <li key={index}><span>{batch}</span></li>
                    )}
                  </ul>
                </div>
              </MyPATDialog>
            </div>}
          </li>
          <li>
            {!!centerList.length && <div className='batchCenterName'>
              <h6 className='titleHead'>Centre name: </h6>&nbsp;
              <ul className='batchCenterListing'>
                <li>{this.displayListName(centerList, VERSION_PROPERTY.NAME)}</li>
              </ul>
              {!!this.displayListLength(centerList) && <span className='batchCenterText' onClick={() => this.centerPopupClick(centerList)}>+{this.displayListLength(centerList)} </span>}
              <MyPATDialog
                classes={{ root: classes.batchDetailsModal }}
                dialogOpen={centerContainerList.length}
                onDialogClose={false}
                otherDialogProps={{
                  fullWidth: true,
                  maxWidth: 'sm',
                }}
              >
                <button className='closeBtn' onClick={() => this.centerPopupClick([])}><img src='/assets/svg/course-plan-request/close-modal-ic.svg' alt="Close" /></button>
                <h6 className='title'>Centre Details</h6>
                <div className='centerListingCol'>
                  <ul className='centerListing'>
                    {(centerContainerList).map((centre: any, index: number) =>
                      <li key={index}><span className='badge'>Center {index + 1}</span><span>{centre.name}</span></li>
                    )}
                  </ul>
                </div>
              </MyPATDialog>
            </div>}
          </li>
          </>
        }
          {this.getBusinessTypeAvailability(courseInfo) &&
            <li>
              <div className='batchCenterName'>
                <h6 className='titleHead'>Business Type: </h6>&nbsp;
                {courseInfo.availableForCRP && <span className={classes.businessType}>CRP</span>}
                {courseInfo.availableForCRP && (courseInfo.availableForNCRP) && <span>
                   , &nbsp;
                </span>}
                {courseInfo.availableForNCRP && <span className={classes.businessType}>NCRP</span>}&nbsp;
                {courseInfo.availableForB2C && (courseInfo.availableForNCRP || courseInfo.availableForCRP) && <span>
                   , &nbsp;
                </span>}
                {courseInfo.availableForB2C && <span className={classes.businessType}>B2C</span>}
              </div>
            </li>
      }
        </ul>

      </Grid>
      );
    }

    getBatchList = (centerList: any[]) => {
      const batches: any[] = [];
      centerList.forEach((center: any) => {
        (center.batches || []).forEach((batch: any) => {
          batches.push(batch.batchCode || batch.name);
        });
      });

      return batches;
    }
    
    getBusinessTypeAvailability(version: Version) {
      return version.availableForB2C || version.availableForCRP || version.availableForNCRP;
    }

   showVersion=()=>{
     const {course,classes}=this.props;
     const{versions}=course;
     const rankRange=_.get(version,"goalLevels.name",'');
       return versions.map((version,index)=>{
         const centerList: any = version.centers || [];
         const batchList: any = this.getBatchList(centerList);
           return(
           <>  
           <Divider/>
						<Grid container className={classes.mainContentArea}>
              <Grid item xs={8} onClick={() => this.handleOnClick(version.id,"version")}>
                <Grid container justify="flex-start" alignItems="center">
                      <Grid item> 
                        <span className={classes.versionName}>{version.name}</span>
                        <span className={classes.customChip}>
                          <Chip
                            label={_.capitalize(version.status)}
                            className={this.getStatusColorCode(version.status)}
                            classes={{ label: classes.chipLabel }} variant="outlined" />
                        </span>
                        {/* <span className={classes.incompleteColor}>60% Incomplete</span> */}
                      </Grid>
                      {
                        !_.isEmpty(rankRange) &&
                        <>
                      <Grid item>
                         <span className={classes.versionLabel}>For Rank Range:&nbsp;</span> 
                         <span className={classes.versionRank}> {rankRange} </span>
                      </Grid>
                        </>
                      }
                  </Grid>
              </Grid> 
              <Grid item xs={4} onClick={() => this.handleOnClick(version.id,"version")}>
                <Grid container justify="flex-end">
                  <span className={classes.versionLabel}>Course Start -&nbsp;</span>  
                  <span className={classes.versionRank}> {format(new Date(version.startDate), "MMM yyyy")}</span>
                  <img src="/assets/svg/myLibrary/pagination/arrow-right.svg" className={classes.ml12}/>
                </Grid>
              </Grid>
                {this.showBatchAndCenter(version)}
            </Grid>
           </> 
          );
        }); 
   }
   getCourseIcon(course: any) {
     if(course.type === 'standard') {
       return <img id={course._id} src="/assets/svg/myLibrary/blueBook.svg" onMouseOver={this.handleHover.bind(this)}
       onMouseOut={this.handleHover.bind(this)}/>
     } else if(course.type === 'testSeries') {
      return <img id={course._id} src="/assets/svg/myLibrary/yellowBook.svg" onMouseOver={this.handleHover.bind(this)}
      onMouseOut={this.handleHover.bind(this)}/>
     } else {
       return <img id={course._id} src="/assets/svg/myLibrary/redBook.svg" onMouseOver={this.handleHover.bind(this)}
       onMouseOut={this.handleHover.bind(this)}/>
     }
   }

   getTooltipValue(type: string) {
    if(type === 'standard') {
      return 'Standard Course'
    } else if(type === 'testSeries') {
     return 'Test Series'
    } else {
      return 'Combo Course'
    }
  }
    render() {
      const { course, classes } = this.props;
      const { showVersion, showTooltip, selectedHoverCourse } = this.state;
      
      //  // for tempory purpose 
      const courseDetails=_.get(course,"courseDetails",[]);
      const courseNameArray :any []=[];
      courseDetails.forEach((courseDetails:any)=>{
         courseNameArray.push(courseDetails.courseName);
      });
      const courseName=courseNameArray.join(', ');
      const startDate=_.get(course,"startDate","");
      const expiryDate=_.get(course,"expiryDate","");
      const{type}=course;
 
      
      return (
        <>
        <Paper
				classes={{ root: classes.paper }}
				elevation={24}>

				<Grid container className={classes.mainContentArea} onClick={() => this.handleOnClick(course._id,type,course.status)}>
						<Grid container justify="space-between">
                <Grid item xs={8}>
                  <Grid container justify="flex-start">
                      <Grid title={`${course.name} | ${course.sku}`} item className={classes.width80per}> 
                      <span className={classes.courseTitle}>{`${course.name} | ${course.sku}`}</span>
                      </Grid>
                      <Grid item className={classes.customChip}>
												<Chip
													label={course.status === 'PAST' ? _.capitalize('Expired') : _.capitalize(course.status)}
													className={this.getStatusColorCode(course.status)}
													classes={{ label: classes.chipLabel }} variant="outlined" />
                          {/* <span className={classes.incompleteColor}>60% Incomplete</span> */}
											</Grid>	
                  </Grid>                  
                </Grid>
                <Grid item xs={4}>
                  <Grid container justify="flex-end">
                     <Grid item>
                     {type!==CourseTypes.testSeries &&course.versions && course.versions.length>0 && <Typography align="right">
                         <Grid onClick={(e) => this.handleVersion(e)} className={classes.collapseLink}>
                           <Typography className={(showVersion==false) ? classes.rotateImg: classes.arrowIcon}>
                            Version {course.versions.length}&nbsp;<img src="/assets/svg/myLibrary/primaryArrow.svg"/></Typography>	
                         </Grid>
                      </Typography>}
                      
                    </Grid> 
               </Grid>
               </Grid>   
            </Grid>
            <Grid container justify="space-between" alignItems="center">
              <Grid item className={classes.imageAlign}>
                   {this.getCourseIcon(course)}
                   <span className={classes.tooltipDetails}>
                                  {
                                    showTooltip && selectedHoverCourse === course._id &&
                                    <>
                                      <CustomInfoIcon
                                        isInfoIcon={false}
                                        isCenterArrow={false}
                                        isRightArrow={showTooltip}
                                        details={this.getTooltipValue(course.type)}
                                        toolTipDirection="right" />
                                    </>
                                  }

                                </span>
                  <span className={classes.courseName}>{courseName}</span>
              </Grid>
              <Grid item>
                <span className={classes.dateStyle}>{format(new Date(startDate||Date.now()), "dd-MMM-yyyy")} <span>to</span> {format(new Date(expiryDate||Date.now()), "dd-MMM-yyyy")} </span>
              </Grid>
            </Grid>
         </Grid>
          {this.showBatchAndCenter(course)}
         {showVersion&&this.showVersion()
          } 
         </Paper>  
        </>        
      );
    }
  }
  
  const mapStateToProps = (state: any) => ({
  });
  
  const mapDispatchToProps = (dispatch: any) => bindActionCreators({

  }, dispatch);
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
    // @ts-ignore
  )(withStyles(styles)(withRouter(CourseCard)));
  
